import { Grid } from "@mui/material";
import {useEffect, useState} from "react";
import {API} from "../framework/api";
import {TXT_SUBTITLE} from "../framework/constants";
import {confirmAlert} from "react-confirm-alert";
import {Menu} from "../component/Menu";
import {MENU_ITEMS} from "../framework/constants";
import {AddCircle, DeleteForever} from "@mui/icons-material";
import {AssignmentReplies} from "../component/AssignmentReplies";
import {ReplyArea} from "../component/ReplyArea";

export function AnslagstavlanPage(props) {
  const [assignments, setAssignments] = useState([]);

  useEffect(() => {
    updateAssignments();
  }, []);

  const updateAssignments = () => {
    API.getAPI().get_assignments().then((response)=> {
      setAssignments(response.data);
    });
  };

  const deleteAssignment = (i, assignment) => {
    confirmAlert({
      title: "Är du säker?",
      message: `Är du säker på att du vill ta bort Uppdrag ${i + 1}? Åtgärden kan inte ångras.`,
      buttons: [{
        label: "Ta bort",
        onClick: () => {
          API.getAPI().delete_assignment(assignment.id).then((response) => {
            setAssignments(response.data);
          });
        }
      }, {
        label: "Avbryt",
        onClick: () => {}
      }]
    });

  }

  return (
    <div>
      <div className={"App-title-withSubtitle"}>Välkommen till anslagstavlan</div>
      <div className={"App-subTitle"}>{TXT_SUBTITLE}</div>
      <Grid container={true} spacing={0} className={"App-drop-shadow"}>
        <Grid item xs={12} md={3} className={"App-container-leftMenu"}>
          <Menu items={MENU_ITEMS} />
        </Grid>
        <Grid item xs={12} md={9} className={"App-container-rightContent"}>
          <Grid container={true} spacing={0}>
            {assignments.map((assignment, i) => (
              <Grid item xs={12} md={12}>
                <div className={"App-rightContent"}>
                  <div className={"App-fieldTitle u-flex"}>
                    <div className={"u-flex"}>
                      Uppdrag {i + 1}
                    </div>
                    <div className={"u-flex u-sendRight u-colorDimmed u-clickable"} onClick={() => { deleteAssignment(i, assignment) }}>
                      <DeleteForever />
                    </div>
                  </div>
                  <div className={"u-marginT8 u-preWrap"}>
                  {assignment.assignmentText}
                  </div>
                  {assignment.replies.length > 0 ? <div className={"u-marginT20"}>
                    <AssignmentReplies replies={assignment.replies} />
                    <div className={"u-textRight"}>
                      <ReplyArea assignmentId={assignment.id} onChange={updateAssignments} />
                    </div>
                  </div> : null}
                </div>
              </Grid>
            ))}
            <Grid item xs={12} md={12}>
              <div className={"App-rightContent-addAssignment"} onClick={() => { document.location.hash="#/uppdrag"; }}>
                <div>
                  <AddCircle style={{height:32, width:32}} />
                </div>
                <div>
                  Lägg till önskeuppdrag
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
